/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp {
    export class DateTimeHelper {

        public static GetLongTimeZoneName(): string {
            var timeZoneName = "";
            var timeString = new Date().toString();
            var beginIndex = timeString.indexOf("(");
            var endIndex = timeString.indexOf(")");
            if (timeString && beginIndex && endIndex) {
                var stringLength = endIndex - beginIndex - 1;
                timeZoneName = timeString.substr(beginIndex + 1, stringLength);
                // Edge strings contained special right mark control character (8206) as the first char.
                if (timeZoneName.charCodeAt(0) === 8206) {
                    timeZoneName = timeZoneName.substr(1);
                }
            }

            return timeZoneName;
        }

        public static GetTimeZoneNameWithoutDaylightOrStandard(): string {
            return DateTimeHelper.GetLongTimeZoneName().replace(" Standard Time", " Time").replace(" Daylight Time", " Time");
        }
    }
} 